import { Dialog, Tab, Transition } from "@headlessui/react";
import CommentListing from "components/CommentListing/CommentListing";
import ExperiencesCard from "components/ExperiencesCard/ExperiencesCard";
import StartRating from "components/StartRating/StartRating";
import StayCard from "components/StayCard/StayCard";
import { FC, Fragment, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import SocialsList from "shared/SocialsList/SocialsList";
import { Helmet } from "react-helmet";
import moment from "moment";
import { useChangeHostPasswordMutation, useGetMeQuery, useUpdateHostSelfMutation, useUploadAvatarMutation } from "application/features/host/hostApiSlice";
import { useDispatch } from "react-redux";
import { setHost } from "application/features/host/hostSlice";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useLazyGetReviewsByHostUUIDQuery } from "application/features/review/reviewApiSlice";
import Pagination from "shared/Pagination/Pagination";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Textarea from "shared/Textarea/Textarea";
import { toast } from "react-toastify";
import InputPsw from "shared/InputPsw/InputPsw";

export interface AuthorPageProps {
  className?: string;
}

const AuthorPage: FC<AuthorPageProps> = ({ className = "" }) => {
  const [fetchReviews, { data: reviews, isLoading: isLoadingReviews, isSuccess: isSuccessReviews }] = useLazyGetReviewsByHostUUIDQuery();
  const [updateHostSelf, { data, isLoading: updatingHost }] = useUpdateHostSelfMutation({});
  const [changePassword, { data: changePasswordData, isLoading: changingPassword }] = useChangeHostPasswordMutation({});
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");


  const { data: host, isLoading, isError } = useGetMeQuery({});

  const dispatch = useDispatch();
  const [hostUpdated, setHostUpdated] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [uploadAvatar, { isLoading: isUploading }] = useUploadAvatarMutation();
  const [imageUrl, setImageUrl] = useState<string>(host.avatar ? host.avatar : "");

  useEffect(() => {
    if (host) {
      dispatch(setHost({ ...host }))
    }
  }, [isLoading]);

  useEffect(() => {
    fetchReviews({ host_uuid: host?.host_uuid, page: 1 })
  }, [host])

  let [categories] = useState(["Pacchetti", "Strutture", "Esperienze"]);

  const handleUpdateHost = (field: string, value: any) => {
    let newHost = { ...host, [field]: value }
    setHostUpdated(newHost);
  }

  const handleChangeImage = async (e: any) => {
    try {
      const url = URL.createObjectURL(e.target.files[0]);
      setImageUrl(url)

      const formData = new FormData()
      formData.append('avatar', e.target.files[0])

      const upload = await uploadAvatar(formData).unwrap();
      handleUpdateHost("avatar", upload.host[0].avatar)
    }
    catch (err) {
      console.log(err)
    }
  }

  const handleChangePassword = async () => {
    try {
      const changePsw = await changePassword({ oldPassword, newPassword }).unwrap();
      toast.success("Password cambiata con successo")
    }
    catch (err) {
      console.log(err);
      toast.error("Errore nel cambio della password")
    }
  }

  const submitUpdateHost = async (e: any) => {
    try {
      e.preventDefault()
      updateHostSelf({ host: hostUpdated }).unwrap();
      dispatch(setHost({ ...hostUpdated }))
      toast.success("Dati aggiornati con successo")
    }
    catch (err) {
      toast.error("Errore nell'aggiornamento dei dati")
      console.log(err)
    }
  }


  const checkDisabled = () => {
    // if all fields are the same as the original host, then disable the button, check if all fields are filled
    if (hostUpdated.name === host.name && hostUpdated.email === host.email && hostUpdated.phone === host.phone && hostUpdated.description === host.description && hostUpdated.city === host.city && hostUpdated.address === host.address) {
      return true
    }
    if (hostUpdated.name === "" || hostUpdated.email === "" || hostUpdated.phone === "" || hostUpdated.description === "" || hostUpdated.city === "" || hostUpdated.address === "") {
      return true
    }
    return false
  }

  const onChangePicture = () => {
    setShowImageModal(true);
  };

  const renderSidebar = () => {
    return (
      <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
        <Avatar
          hasChecked
          hasCheckedClass="w-6 h-6 -top-0.5 right-2"
          sizeClass="w-28 h-28"
          imgUrl={imageUrl}
          changePictureIcon={true}
          onChangePicture={onChangePicture}
        />

        <Transition.Root show={showImageModal} as={Fragment}>
          <Dialog open={showImageModal} onClose={() => setShowImageModal(false)} as="div">
            <Transition.Child
              as={Fragment}
              enter="transition-opacity duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30" />
            </Transition.Child>

            <Transition.Child
              as={Fragment}
              enter="transition ease-out duration-300"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition ease-in duration-200"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-white dark:bg-neutral-900">
                <Dialog.Panel>
                  <Dialog.Title className="text-lg font-semibold dark:text-neutral-50">Cambia immagine profilo</Dialog.Title>
                  <Dialog.Description className="mb-8 dark:text-neutral-400">
                    Seleziona una immagine dal tuo dispositivo per aggiornare la tua foto profilo.
                  </Dialog.Description>

                  {
                    isUploading ?
                      <div className="w-32 h-32 ">
                        <Skeleton className="h-full rounded-full" />
                      </div>
                      :
                      <div className="flex-shrink-0 flex items-center justify-center">
                        <div className="relative rounded-full overflow-hidden flex">
                          <Avatar imgUrl={imageUrl} sizeClass="w-32 h-32" />
                          <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-neutral-50 cursor-pointer">
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V20M5 20V22.5C5 23.163 5.26339 23.7989 5.73223 24.2678C6.20107 24.7366 6.83696 25 7.5 25H22.5C23.163 25 23.7989 24.7366 24.2678 24.2678C24.7366 23.7989 25 23.163 25 22.5V17.5M5 20L10.7325 14.2675C11.2013 13.7988 11.8371 13.5355 12.5 13.5355C13.1629 13.5355 13.7987 13.7988 14.2675 14.2675L17.5 17.5M25 12.5V17.5M25 17.5L23.0175 15.5175C22.5487 15.0488 21.9129 14.7855 21.25 14.7855C20.5871 14.7855 19.9513 15.0488 19.4825 15.5175L17.5 17.5M17.5 17.5L20 20M22.5 5H27.5M25 2.5V7.5M17.5 10H17.5125"
                                stroke="currentColor"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <span className="mt-1 text-xs">Carica foto</span>
                          </div>
                          <input
                            type="file"
                            name="new-avatar"
                            onChange={(e) => handleChangeImage(e)}
                            className="absolute inset-0 opacity-0 cursor-pointer"
                            placeholder="Carica foto profilo"
                          />
                        </div>
                      </div>
                  }

                  <div className="flex justify-end space-x-2">
                    <button onClick={() => setShowImageModal(false)}>Chiudi</button>
                  </div>
                </Dialog.Panel>
              </div>
            </Transition.Child>
          </Dialog>
        </Transition.Root>

        {/* ---- */}
        <div className="space-y-3 text-center flex flex-col items-center">
          <h2 className="text-3xl font-semibold">{host.name}</h2>
          <StartRating point={host.rating?.toFixed(1)} reviewCount={host.reviews_count} className="!text-base" />
        </div>

        {/* ---- */}
        <p className="text-neutral-500 dark:text-neutral-400">
          {host.description}
        </p>

        {/* ---- */}
        {host.socials &&
          <SocialsList
            className="!space-x-3"
            itemClass="flex items-center justify-center w-9 h-9 rounded-full bg-neutral-100 dark:bg-neutral-800 text-xl"
          />
        }

        {/* ---- */}
        <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

        {/* ---- */}
        <div className="space-y-4">
          <div className="flex items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-neutral-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            <span className="text-neutral-6000 dark:text-neutral-300 capitalize">
              {host.city} - {host.state}
            </span>
          </div>
          <div className="flex items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-neutral-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            {
              host.created_at &&
              <span className="text-neutral-6000 dark:text-neutral-300">
                host TRIBYOU da {moment(host.created_at).format("DD MMM YYYY")}
              </span>
            }
          </div>
        </div>
      </div>
    );
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Servizi</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Questi sono i servizi che offri ai tuoi clienti. Puoi combinare strutture e esperienze insieme per creare pacchetti e offrire unicità ai tuoi clienti.
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        <div>
          <Tab.Group>
            <Tab.List className="flex space-x-1 overflow-x-auto">
              {categories.map((item) => (
                <Tab key={item} as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                        ? "bg-secondary-900 text-secondary-50 "
                        : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                        } `}
                    >
                      {item}
                    </button>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels>
              <Tab.Panel className="">
                <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
                  {[].filter((_, i) => i < 4).map((stay) => (
                    <StayCard key={stay.id} data={stay} />
                  ))}
                </div>
                <div className="flex mt-11 justify-center items-center">
                  <ButtonSecondary>Scopri di più</ButtonSecondary>
                </div>
              </Tab.Panel>
              <Tab.Panel className="">
                <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
                  {[].filter((_, i) => i < 4).map(
                    (stay) => (
                      <ExperiencesCard key={stay.id} data={stay} />
                    )
                  )}
                </div>
                <div className="flex mt-11 justify-center items-center">
                  <ButtonSecondary>Scopri di più</ButtonSecondary>
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Recensioni ({Math.round(reviews?.data?.length * reviews?.totalPages)} recensioni)</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* comment */}
        <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
          {
            reviews?.data?.map((review: any) => (
              <CommentListing key={`review-${review.review_uuid}`} data={review} />
            ))
          }
        </div>
        <div className="w-full items-center justify-center flex">
          <Pagination
            totalPages={reviews?.totalPages || 0}
            currentPage={reviews?.currentPage || 0}
            onPageChange={(page) => fetchReviews({ host_uuid: host?.host_uuid, page })}
          />
        </div>
      </div>
    );
  };

  const renderSection3 = () => {
    return (
      <div className="listingSection__wrap">
        {/* form to change data */}
        <h2 className="text-3xl font-semibold">Gestisci i tuoi dati</h2>
        <form onSubmit={(e) => submitUpdateHost(e)}>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
              >
                Nome
              </label>
              <Input
                id="name"
                name="name"
                type="text"
                placeholder="Nome"
                defaultValue={host.name}
                onChange={(e) => handleUpdateHost("name", e.target.value)}
                className="mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
              >
                Email
              </label>
              <Input
                id="email"
                name="email"
                type="email"
                placeholder="Email"
                defaultValue={host.email}
                onChange={(e) => handleUpdateHost("email", e.target.value)}
                className="mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="description"
                className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
              >
                Descrizione
              </label>
              <Textarea
                id="description"
                name="description"
                placeholder="Descrizione"
                onChange={(e) => handleUpdateHost("description", e.target.value)}
                defaultValue={host.description}
                className="mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="city"
                className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
              >
                Città
              </label>
              <Input
                id="city"
                name="city"
                type="text"
                placeholder="Città"
                onChange={(e) => handleUpdateHost("city", e.target.value)}
                defaultValue={host.city}
                className="mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="address"
                className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
              >
                Indirizzo
              </label>
              <Input
                id="address"
                name="address"
                type="text"
                placeholder="Indirizzo"
                onChange={(e) => handleUpdateHost("address", e.target.value)}
                defaultValue={host.address}
                className="mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="address"
                className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
              >
                Codice postale
              </label>
              <Input
                id="postal_code"
                name="postal_code"
                type="text"
                placeholder="Codice postale"
                onChange={(e) => handleUpdateHost("postal_code", e.target.value)}
                defaultValue={host.postal_code}
                className="mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
              >
                Telefono
              </label>
              <Input
                id="phone"
                name="phone"
                type="text"
                placeholder="Telefono"
                defaultValue={host.phone}
                onChange={(e) => handleUpdateHost("phone", e.target.value)}
                className="mt-1"
              />
            </div>
          </div>
          <div className="flex flex-row items-center justify-end mt-6 gap-6">
            <span
              className="text-primary-6000 cursor-pointer hover:opacity-90"
              onClick={() => setShowModal(true)}
            >
              Cambia password
            </span>
            <ButtonPrimary
              type="submit"
              loading={updatingHost}
              disabled={checkDisabled()}
            >
              Salva
            </ButtonPrimary>
          </div>
        </form>
      </div>
    );
  };
  return (
    <div className={`nc-AuthorPage ${className}`} data-nc-id="AuthorPage">
      <Helmet>
        <title>Mio profilo | TRIBYOU</title>
      </Helmet>
      <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="block flex-grow mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24">{!isLoading ? renderSidebar() : <Skeleton className="h-[20rem]" />}</div>
        </div>
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          {host && !isLoading && !isLoadingReviews ? renderSection2() : <Skeleton className="h-[20rem]" />}
          {host && !isLoading && !isLoadingReviews ? renderSection3() : <Skeleton className="h-[20rem]" />}

        </div>
      </main>
      <>
        <Transition.Root show={showModal} as={Fragment}>
          <Dialog as="div" onClose={() => null}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30" />
            </Transition.Child>

            <Transition.Child
              as={Fragment}
              enter="transition ease-out duration-300"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition ease-in duration-200"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <div className="fixed inset-0 flex items-center justify-center p-5 md:p-0">
                <div className="bg-white rounded-lg p-10 flex items-start flex-col justify-center w-full md:w-[30rem]">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                    Cambia la tua password
                  </Dialog.Title>
                  <div className="w-full my-3 relative">
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
                    >
                      Password attuale
                    </label>
                      <InputPsw
                        id="oldPassword"
                        onChange={(e) => setOldPassword(e.target.value)}
                        name="oldPassword"
                        type="password"
                        placeholder="Password"
                        className="mt-1"
                      />
                    <label
                      htmlFor="newPassword"
                      className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mt-2"
                    >
                      Nuova password
                    </label>
                    <InputPsw
                      id="newPassword"
                      onChange={(e) => setNewPassword(e.target.value)}
                      name="newPassword"
                      type="password"
                      placeholder="Nuova password"
                      className="mt-1"
                    />
                  </div>
                  <div className="mt-4 flex flex-row gap-3">
                    <ButtonSecondary
                      onClick={() => setShowModal(false)}
                    >
                      Chiudi
                    </ButtonSecondary>
                    <ButtonPrimary
                      onClick={handleChangePassword}
                      loading={changingPassword}
                    >
                      Cambia password
                    </ButtonPrimary>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </Dialog>
        </Transition.Root>
      </>
    </div>
  );
};

export default AuthorPage;
